import { Component, ViewChild } from '@angular/core';
import { CustomerTableViewComponent } from '../../../components/customer/customer-table-view/customer-table-view.component';
import { AccessManager } from '../../../components/ui/access-manager/access-manager';
import { FilterableTableComponent } from '../../../components/ui/filterable-table/filterable-table.component';
import { TableView } from '../../../components/ui/filterable-table/tableView';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { StorageService } from '../../../core/storage/storageService';
import { Customer } from '../../../models/customer/customer';
import { CustomerService } from '../../../models/customer/customerService';
import { Merchant } from '../../../models/merchant/merchant';
import { Options } from '../../../components/ui/filterable-table/options';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddCustomerDialogComponent } from '../../../components/customer/add-customer-dialog/add-customer-dialog.component';
import { AddCustomerMode } from '../../../components/customer/add-customer/add-customer.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-customer-vault',
  templateUrl: './customer-vault.component.html',
  standalone: false,
})
export class CustomerVaultComponent {
  public PAGE_ACCESS_NAMESPACE: string = AccessManager.AUTH_SELECT_MERCHANT_CUSTOMERS;

  editingCustomer: boolean = false;
  merchant: Merchant | undefined = undefined;
  renderTable: boolean | undefined;

  tableView: any;
  options: Options = new Options({});

  @ViewChild('customersTable') customersTable:
    | FilterableTableComponent
    | undefined;

  customer: Partial<Customer> | undefined;

  constructor(
    public storage: StorageService,
    public customerService: CustomerService,
    public accessManager: AccessManager,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.tableView = new TableView(CustomerTableViewComponent);
    this.merchant = this.storage.getSelectedLocation();
    this.options = new Options({
      filterable: true,
      selectAction: 'other',
      allowEditing: true,
    });
    if (this.merchant) {
      this.options.merchantId = this.merchant.id;
      this.renderTable = true;
    } else {
      this.accessManager
        .getUserAccess(AccessManager.AUTH_SELECT_ALL_CUSTOMERS)
        .then((resp: Record<string, boolean>) => {
          this.renderTable = Boolean(
            resp[AccessManager.AUTH_SELECT_ALL_CUSTOMERS],
          );
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }

  ngAfterViewInit(): void {
    // lol gross
    const intId = setInterval(() => {
      // this.renderTable must begin as undefined and MUST be set
      // to a value in ngOnInit
      if (this.renderTable == null) {
        return;
      }
      if (this.renderTable) {
        this.customersTable?.loadComponent();
        // TODO (jacob): http errors generated here are not
        //               displayed to the user
        this.customersTable?.setOptions(this.options);
        clearInterval(intId);
      } else {
        clearInterval(intId);
      }
    }, 30);
  }

  //  public setCustomerDataSource(dataSource: MatTableDataSource<Customer>) {
  //    this.customerDataSource = dataSource;
  //    this.customer = undefined;
  //  }

  public clearCustomerSelection() {
    this.customer = undefined;
    //this.customersTable?.clearSelection();
  }

  public async _openCustomerDialog(mode: AddCustomerMode, customer?: Partial<Customer>) {
    const config = new MatDialogConfig();
    config.disableClose = true;        // ESC key won't close it either, if you want that too
    config.hasBackdrop = true;
    config.backdropClass = 'dark-backdrop';
    config.panelClass = 'square-white-dialog';
    config.autoFocus = true;
    config.width ='90vw';
    config.height ='90vh';
    config.maxWidth = '800px';

    config.data = { merchantId: this.merchant?.id, customer, mode }
    
    const result = await this.dialog.open(AddCustomerDialogComponent, config);

    // refresh table if changes were made
    return result;
  }

  public async btnInitNewCustomer_click() {
    this.editingCustomer = true
    const dialogRef = await this._openCustomerDialog('add');
    await firstValueFrom(dialogRef.afterClosed());
    this.editingCustomer = false;
    (this.customersTable?.tableComponent?.instance as CustomerTableViewComponent)?.reloadCachedRequest();
  }


  public async handleCustomerSelected(customer: Customer) {
    this.editingCustomer = true;
    const customerWithDetails = await this.customerService.getCustomerById(customer.id)
    const dialogRef = await this._openCustomerDialog('edit', customerWithDetails);
    await firstValueFrom(dialogRef.afterClosed());
    this.editingCustomer = false;
    (this.customersTable?.tableComponent?.instance as CustomerTableViewComponent)?.reloadCachedRequest();
  }

  /* temp filtering */
  selectedFilterType: string = '';

  btnSaveFilter_click() {
    let table: HTMLTableElement | null = document.getElementById(
      'filterTable',
    ) as HTMLTableElement;
    let row = table.insertRow(-1);

    let cell1 = row.insertCell(0);
    let cell2 = row.insertCell(1);

    let that = this;
    let rowIndex = table.rows.length - 1;

    let deleteButton = document.createElement('button');
    deleteButton.innerHTML = 'X';
    deleteButton.addEventListener('click', (e) => {
      that.btnRemoveFilter_click(rowIndex);
    });

    cell1.append(deleteButton);

    if (this.selectedFilterType == 'customer') {
      let customerQuery = (
        document.getElementById('txtCustomer') as HTMLInputElement
      ).value;
      cell2.innerHTML = 'Customer name contains "' + customerQuery + '"';
    } else if (this.selectedFilterType == 'type') {
      let type = (document.getElementById('ddlType') as HTMLSelectElement)
        .selectedOptions[0].value;
      cell2.innerHTML = 'Transaction type = ' + type;
    }
  }

  btnRemoveFilter_click(rowIndex: number) {
    let table: HTMLTableElement | null = document.getElementById(
      'filterTable',
    ) as HTMLTableElement;
    table.deleteRow(rowIndex);

    // re-query...
  }

  /**************** */
}
